
import {
  defineComponent, shallowRef, onMounted, ref, watch, computed, onUnmounted,
} from 'vue';
import {
  Dropdown, Menu, Slider,
} from 'ant-design-vue';
import moment from 'moment';
import * as echarts from 'echarts';

import store from '@/store';

import {
  getCaronData,
} from '../caronMonit';

const { Item, } = Menu;

export default defineComponent({
  components: {
    Dropdown,
    Menu,
    Item,
    Slider,
  },
  props: {
    caronType: {
      type: String,
      default: 'NPP',
      require: true,
    },
  },
  setup (props) {
    // 是否有数据
    const isEmpty = ref(false);
    // 生成唯一的五位id，用于区别不同页面的调用
    const id = (Math.random() * 1e6).toString().substr(0, 5);
    // 折线图图
    const lineChart = shallowRef<any>({});
    // 播放的数据类型
    const currentPlayType = computed(() => store.state.caron.currentPlayType);
    // 数据
    const carbonTime = ref({});
    let carbonFluxTimeNPP = {};
    let carbonFluxNPP = {};
    // 播放选项
    const isPlay = ref<boolean>(false);
    // 当前播放时间
    const current = ref(0);
    // 结束时间
    const max = ref(1);
    let timer: number | null | undefined = null;

    // const { regionId, } = store.state.OLMap;

    // 焦作regionId TODO 测试数据

    const regionId = '410800000000';

    // 配置项
    const lineOptions = {
      color: ['#59B7B9',
        '#7EE8FC',
        '#CCE14C',
        '#8359F6',
        '#5B8AF7',
        '#76D174',
        '#6E74F6',
        '#E6AA43',
        '#D285EE',
        '#F07B7B',],
      legend: {
        show: true,
        icon: 'circle',
        textStyle: {
          fontSize: 12,
          color: '#222222',
          rich: {
            // 数字下标
            sub: {
              verticalAlign: 'bottom',
              fontSize: 8,
            },
          },
        },
        formatter (name:string) {
          return name
            .replace('CO2', 'CO{sub|2}')
            .replace('CH4', 'CH{sub|4}');
        },
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.6)',
        borderWidth: 0,
        position: (pos:any, params:any, el:any, elRect:any, size:any) => {
          const obj = { top: -33, };

          obj[['left', 'right',][Number(pos[0] < size.viewSize[0] / 2)]] = 30;

          return obj;
        },
        textStyle: {
          color: '#fff',
          fontSize: 12,
          align: 'left',
        },
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: '#222',
          },
        },
      },
      grid: {
        show: false,
        bottom: '10%',
        top: '34%',
      },
      xAxis: {
        type: 'category',
        data: [],
        axisLabel: {
          textStyle: {
            color: '#222222',
            fontSize: 10,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#E5E6EB',
          },
        },
        axisTick: {
          show: true,
          inside: true,
        },
      },
      yAxis: {
        type: 'value',
        name: 'gC/m^2',
        nameTextStyle: {
          color: '#3880F2',
          fontSize: 12,
        },
        axisLabel: {
          textStyle: {
            color: '#222222',
            fontSize: 10,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#E5E6EB',
          },
        },
        axisTick: {
          show: true,
          inside: true,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#E5E6EB',
          },
        },
      },
      series: [] as any[],
    };

    const initChart = () => {
      const lineChartContainer = document.getElementById(`${id}caron-chart`) as HTMLElement;

      lineChart.value = echarts.init(lineChartContainer);
    };
    const drawChart = (data:any): void => {
      // 数据渲染
      lineOptions.xAxis.data = data.time;
      const series:any[] = [];

      Object.keys(data).forEach((item, index) => {
        if (item !== 'time') {
          series.push({
            name: item,
            type: 'line',
            data: data[item],
          });
        }
      });
      lineOptions.series = series;
      lineChart.value.setOption(lineOptions);
    };

    // 进度条渲染提示
    const tipFormatter = () => {
      if (Object.keys(carbonFluxTimeNPP).length) {
        return moment(Object.keys(carbonFluxTimeNPP)[current.value], 'YYYYMMDD').format('MM月DD日');
      }

      return null;
    };

    // 更新store中的值
    const setItem = (item:string,val:any) => {
      store.commit('caron/setStateItem',{ value: val, type: item, });
    };

    // 暂停播放
    const stopPlay = () => {
      if (timer) {
        clearInterval(timer);
      }
      timer = null;
    };

    // 进度条数据初始化
    const initPlayer = () => {
      // current.value = Object.keys(carbonFluxTimeNPP).length - 1;
      max.value = Object.keys(carbonFluxTimeNPP).length - 1;
      current.value = max.value;
      stopPlay();
    };

    // 处理当前实时影像 添加图层
    const handleCurrent = (key:number) => {
      const curDate = Object.keys(carbonFluxTimeNPP)[key];
      const data = carbonFluxTimeNPP[curDate];

      setItem('mapData',{ data,curDate,type: props.caronType, });
      if (key === max.value) {
        stopPlay();
        isPlay.value = true;
      }
    };
    // 开始播放
    const startPlay = () => {
      setItem('currentPlayType',props.caronType);
      timer = setInterval(() => {
        current.value += 1;
        handleCurrent(current.value);
      }, 1000);
    };
    // 播放
    const handlePlayer = () => {
      isPlay.value = !isPlay.value;
      if (isPlay.value) {
        // 末位重置
        if (current.value === max.value) {
          current.value = 0;
          handleCurrent(0);
        }
        startPlay();
      } else {
        stopPlay();
      }
    };

    // 进度条变化回调
    const handleSliderChange = (value:number) => {
      current.value = value;
      handleCurrent(value);
      if (value === max.value) {
        isPlay.value = false;
        stopPlay();
      }
    };

    watch(currentPlayType,(val:string) => {
      if (val !== props.caronType) {
        stopPlay();
        isPlay.value = false;
        // current.value = 0;
      }
    });

    onMounted(() => {
      initChart();
      getCaronData(regionId,props.caronType).then((res:any) => {
        carbonFluxNPP = res.carbonFluxNPP;
        carbonFluxTimeNPP = res.carbonFluxTimeNPP;
        if (Object.keys(carbonFluxTimeNPP).length) {
          initPlayer();
          carbonTime.value = Object.keys(carbonFluxTimeNPP);
          drawChart(carbonFluxNPP);
          // 给地图传初始数据
          if (props.caronType === 'NPP') {
            const curDate = Object.keys(carbonFluxTimeNPP)[current.value];
            const data = carbonFluxTimeNPP[curDate];

            setItem('mapData', { data, curDate, type: props.caronType, });
          }
        } else {
          isEmpty.value = true;
        }
      });
    });
    onUnmounted(() => {
      stopPlay();
      setItem('mapData',[]);
      setItem('currentPlayType','');
      echarts.dispose(lineChart.value);
      lineChart.value = null;
    });

    return {
      id,
      carbonTime,
      isPlay,
      currentPlayType,
      current,
      max,
      isEmpty,
      handlePlayer,
      tipFormatter,
      handleSliderChange,
    };
  },
});
